import React from "react";
import VIPLargeCard from "../../../../../components/VIPLargeCard";
import invoicesLogo from "../../../../../assets/images/invoices.png";
import useGetAllVendorInvoiceCount from "../../InvoiceCapture/hooks/useGetVendorInvoiceCount";
interface Props {}
export const TotalNumberInvoicesCard: React.FC<Props> = () => {
  const { data: allVendorInvoiceCount } = useGetAllVendorInvoiceCount();

  return (
    <>
      <VIPLargeCard
        title={"Total Number of Invoices"}
        count={allVendorInvoiceCount}
        className={
          "bg-tabColorDarkBlue border border-gray-200 shadow-md rounded-md"
        }
        src={invoicesLogo}
      />
    </>
  );
};
